// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__7tK-0","tournamentName":"Placeholder_tournamentName__32d8H","badge":"Placeholder_badge__1zD0Y"};